import React from 'react';
import styled from 'styled-components';
import { colorThemeGenerator, ButtonPrimary, Type } from '@spotify-internal/encore-creator-web';
import {
  spacer80,
  spacer32,
  screenMdMin,
  screenLgMin,
  kleinBlue,
  citric,
} from '@spotify-internal/encore-foundation';
import { pageConstraintStyles } from './styles';
import { FormattedMessage } from 'react-intl';
import { WRAPPED_BANNERS_DISPLAY_YEAR } from '../../lib/constants';
import { login } from '../../lib/Request';

export function WrappedHero() {
  return (
    <HeroContainer>
      <HeroImage src="/images/landing_page/wrapped-hero.png" alt="Wrapped logo" />
      <section>
        <HeroText variant={Type.display1}>
          <FormattedMessage
            id="landing-page.hero.wrapped-title"
            defaultMessage="{year} {break} Wrapped {break} for Podcasters"
            values={{ break: <br />, year: WRAPPED_BANNERS_DISPLAY_YEAR }}
          />
        </HeroText>
        <Type as="h2" variant={Type.heading4} style={{ margin: `${spacer32} 0 18px` }}>
          <FormattedMessage
            id="landing-page.hero.wrapped-description"
            defaultMessage="Your voice resonated this year on Spotify. Ready to see your standout moments?"
          />
        </Type>

        <ButtonPrimary
          onClick={login}
          theme={{
            ...colorThemeGenerator({
              primaryColor: citric,
              primaryColorText: kleinBlue,
              primaryColorFocusText: kleinBlue,
              primaryColorActiveText: kleinBlue,
            }),
          }}
          buttonSize={ButtonPrimary.lg}
        >
          <FormattedMessage
            id="landing-page.hero.wrapped-button"
            defaultMessage="Explore Wrapped"
          />
        </ButtonPrimary>
      </section>
    </HeroContainer>
  );
}

const HeroImage = styled.img`
  width: 100%;
  max-width: 440px;

  @media (min-width: ${screenMdMin}) {
    min-width: 440px;
  }
`;

const HeroContainer = styled.div`
  padding: 80px 15px;
  display: grid;
  align-items: center;
  grid-gap: ${spacer32};
  grid-template-columns: 1fr;
  justify-items: center;

  @media (min-width: ${screenMdMin}) {
    ${pageConstraintStyles}
    grid-template-columns: 1fr 2fr;
    grid-gap: ${spacer80};
  }

  @media (max-width: 1100px) and (min-width: ${screenMdMin}) {
    padding-left: 16px;
  }
`;

const HeroText = styled(Type).attrs({
  forwardedAs: 'h1',
})`
  padding: 0;
  font-weight: normal;
  color: ${citric};
  font-size: 60px;
  line-height: 65px;

  @media (min-width: ${screenLgMin}) {
    font-size: 100px;
    line-height: 100px;
  }
`;
